import React from 'react';
import PropTypes from 'prop-types';

import Input2 from '../Input2';
import InputLabelWrapper from '../InputLabelWrapper';
import Placeholder from 'react-select/dist/declarations/src/components/Placeholder';

const InputText2 = ({
  id,
  label,
  className,
  isSortable,
  sortDirection,
  onLabelClick,
  value,
  onChange,
  placeholder,
  labelClassName,
  icon
}) => {
  return (
    // <InputLabelWrapper
    //   label={label}
    //   isSortable={isSortable}
    //   sortDirection={sortDirection}
    //   onLabelClick={onLabelClick}
    // >

    <Input2
      id={id}
      className={className}
      type="text"
      // containerClassName="mr-2"
      // value={value}
      onChange={event => {
        onChange(event.target.value);
      }}
      placeholder={placeholder}
      label={label}
      labelClassName={labelClassName}
      labelChildren={id}
      icon={icon}
    />
    // </InputLabelWrapper>
  );
};

InputText2.defaultProps = {
  value: '',
  isSortable: false,
  onLabelClick: () => { },
  sortDirection: 'none',
};

InputText2.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string.isRequired,
  className: PropTypes.string,
  isSortable: PropTypes.bool,
  sortDirection: PropTypes.oneOf(['ascending', 'descending', 'none']),
  onLabelClick: PropTypes.func,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  labelClassName: PropTypes.string,
};

export default InputText2;
